const defaultTextColorKey = 'TC_General'
const defaultErrorTextColorKey = 'TC_Error'
const defaultBorderColorKey = 'SC_Active_Border'
const defaultBackgroundKey = 'SC_Active_Background'

type WebSkinDetails = {
    textColor: string
    errorTextColor: string
    borderColor: string
    backgroundColor: string
    titleColor: string
}

export const getWebskinDetails = (webskin: any): WebSkinDetails => {
    if(!webskin || typeof webskin === 'string')
        return {
            textColor: '#000000',
            backgroundColor: '#ffffff',
            titleColor: '#036C8F',
            borderColor: '#D5D5D5',
            errorTextColor: '#d83838',
        }

    const fontColors = webskin.textColours
    const siteColors = webskin.siteColours
    
    const textColor = fontColors.find((item: any) => item.code === defaultTextColorKey)?.colourValue || '#000'
    const errorTextColor = fontColors.find((item: any) => item.code === defaultErrorTextColorKey)?.colourValue || '#ca1717'
    const borderColor = siteColors.find((item: any) => item.code === defaultBorderColorKey)?.colourValue || '#000'
    const backgroundColor = siteColors.find((item: any) => item.code === defaultBackgroundKey)?.colourValue || '#fff'

    return {
        textColor,
        errorTextColor,
        borderColor,
        backgroundColor,
        titleColor: textColor
    }
}